export default __webpack_public_path__ + "static/media/app-store-badge.2a82e40f.svg";